import * as React from 'react';
import { TicketSelectionEvalState, OfferType } from 'eTip--common';
import { translationForMts, numberFormatter, DateFormat, TimeFormat, dateFormatter, ITranslationForMts } from 'easit--localization';
import { observer } from 'mobx-react';
import { EventStatus, IEventStatusProps } from '../ticketAndCoupon/eventStatus';
import classNames from 'classnames';

export interface ITicketDetailSelectionsProps {
    selections: ISelection[];
    isSystem: boolean;
    canShowNewFeatureScore: boolean;
    canShowFinalScoreInfo: boolean;
    goToEvent: (id: number, offerType: OfferType, hasLiveEventStatus: boolean) => void | null;
}

export interface ISelection {
    id: string;
    rate: number;
    number: number;
    sportName: string;
    regionName: string;
    tournamentName: string;
    fixtureId: number;
    fixtureName: string;
    fixtureDate: Date;
    resultText: string;
    resultNote: string;
    state: TicketSelectionEvalState;
    isBanker: boolean,
    marketName: string;
    tipName: string;
    symbol: string;
    correctSelectionNames?: string[];
    score: string | null;
    offerType: OfferType;
    liveEventStatus: IEventStatusProps | null;
}

const getStateIcon = (state: TicketSelectionEvalState): React.ReactNode => {
    switch (state) {
        case TicketSelectionEvalState.Cancel: return <span className="state-icon fa fa-minus"></span>;
        case TicketSelectionEvalState.Cashout: return <span className="state-icon fa fa-thumbs-up"></span>;
        case TicketSelectionEvalState.None: return <span className="state-icon fa fa-question"></span>;
        case TicketSelectionEvalState.Loss: return <span className="state-icon fa fa-times"></span>;
        case TicketSelectionEvalState.Storno: return <span className="state-icon fa fa-ban"></span>;
        case TicketSelectionEvalState.Win: return <span className="state-icon fa fa-check"></span>;
        default: return <span className="state-icon fa fa-question"></span>;
    }
}

export const TicketDetailSelections = (props: ITicketDetailSelectionsProps) => {
    const t = translationForMts();
    return props.selections && props.selections.length
        ? <table className="w-100 tip-list selections">
            <thead>
                <tr>
                    {
                        props.isSystem &&
                        <th>{t.ticket_Group}</th>
                    }
                    {/* <th className="text-center">{translation().betList_TicketNumber}</th> */}
                    <th>{t.bet_Match}</th>
                    {/*<th>{props.canShowNewFeatureScore ? t.bet_TipTicketDetail : t.bet_TipWinTip}</th>*/}
                    <th>{t.rate}</th>
                    <th className="result-col"></th>
                </tr>
            </thead>
            <tbody>
                {
                    props.selections.map((selection, idx) => {
                        return <React.Fragment key={idx}>
                            <TicketSelection
                                idx={idx}
                                selection={selection}
                                isSystem={props.isSystem}
                                canShowFinalScoreInfo={props.canShowFinalScoreInfo}
                                canShowNewFeatureScore={props.canShowNewFeatureScore}
                                goToEvent={props.goToEvent}
                                t={t}
                            />
                        </React.Fragment>
                    })
                }
            </tbody>
            {
                props.canShowFinalScoreInfo && <tfoot>
                    <tr><td colSpan={5} className="p-2">{t.bet_FinalScoreInfo}</td></tr>
                </tfoot>
            }
        </table >
        : null
}


interface ITicketSelectionProps {
    idx: number;
    selection: ISelection;
    isSystem: boolean;
    canShowNewFeatureScore: boolean;
    canShowFinalScoreInfo: boolean;
    goToEvent: (id: number, offerType: OfferType, hasLiveEventStatus: boolean) => void | null;
    t: ITranslationForMts;
}

const TicketSelection = observer((props: ITicketSelectionProps) => {
    let selection = props.selection;
    return <><tr className={`${props.idx % 2 === 0 ? 'odd' : 'even'}`}>
        {
            props.isSystem &&
            <td className="text-center align-middle p-2">{selection.symbol}</td>
        }
        {/* <td className="text-center align-middle">{selection.number}</td> */}
        <td className="p-2">
            {props.goToEvent && <a onClick={() => { props.goToEvent(selection.fixtureId, selection.offerType, !!selection.liveEventStatus); return false; }} className="cursor-pointer">
                <span className="event-name pl-0">{selection.fixtureName}</span>
            </a>}
            {
                !props.goToEvent && <span className="event-name pl-0">{selection.fixtureName}</span>
            }
            {
                selection.offerType === OfferType.Live &&
                <span className="live-selection-flag">LIVE</span>
            }
            &nbsp; (<span className="time">{dateFormatter.formatDateTime(selection.fixtureDate, DateFormat.DDMMYYYY, TimeFormat.HHMM)}</span>)
            {
                !!selection.liveEventStatus?.mainScore && <span className="main-result"> {selection.liveEventStatus.mainScore}</span>
            }
            <br />
            {
                selection.liveEventStatus && <EventStatus {...selection.liveEventStatus} />
            }
            {
                selection.sportName &&
                <span className="category">{selection.sportName} / {selection.regionName} / {selection.tournamentName} <br /></span>
            }
            <span className="market-name">{selection.marketName}</span><br />
            <b>{selection.tipName}</b>
            {selection.resultNote && <><br />{selection.resultNote}</>}
            {(props.canShowNewFeatureScore && (selection.score !== null || selection.correctSelectionNames.length > 0)) &&
                <>
                    <br />
                    <span className="result">
                        {<span className="mr-1">{props.t.ticket_SelectionResult}</span>}
                        <span className="px-1">
                            {selection.score}
                            {
                                selection.correctSelectionNames.length > 0 &&
                                <>
                                    {selection.score !== null && <span> / </span>}
                                    {
                                        selection.correctSelectionNames.map((correctTip, idx) => <span key={idx}>{idx !== 0 && <span>, </span>}{correctTip}</span>)
                                    }
                                </>
                            }
                        </span>
                    </span>
                </>}
        </td>
        <td className={classNames("text-center align-middle", __IsMTSTipos__ ? "font-weight-bold" : null)}>{numberFormatter.format(selection.rate)}</td>
        <td className="text-center align-middle icon-col">{getStateIcon(selection.state)}</td>

    </tr>
        <tr className="delimiter-row">
            <td colSpan={5}>
            </td>
        </tr>
    </>
});